import { message } from "antd";
import apiClient from 'services/apiClient';
import { toLower } from "lodash";
import { normalizePhoneNumber } from "../../CustomUtils.js/CampaignUtils";

export const conicColors = {
    '0%': '#16702F',
    '100%': '#34B55A',
};

export const fetchUserStatus = async (userId, api, authToken) => {
    return await apiClient.get(`${api}chek-user/${userId}`, {
        headers: { 'Authorization': `Bearer ${authToken}` },
    });
};
export const formatNumber = (number) => {
    const digits = number.toString();
    if (digits.length === 12) {
        return digits;
    } else if (digits.length === 10) {
        return '91' + digits;
    } else {
        return null;
    }
};
export const filterNumbers = (numbers, blockNumbers, international = false) => {
    const formattedNumbers = (numbers || [])
        .map((value) => normalizePhoneNumber(value, international))
        .filter(Boolean);

    const uniqueNumbers = [...new Set(formattedNumbers)];
    const blockedSet = new Set(
        (blockNumbers || [])
            .map((value) => normalizePhoneNumber(value, international))
            .filter(Boolean)
    );

    return uniqueNumbers.filter((value) => !blockedSet.has(value));
};

export const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth' // Smooth scrolling
    });
};
export const validateUserAndBalance = async (numbersLength, calculateRequredBalance, templateCategory, showModal) => {
    const isEnoughBalance = calculateRequredBalance(numbersLength, toLower(templateCategory));
    // console.log('isEnoughBalance', isEnoughBalance);
    if (isEnoughBalance === false) {
        showModal()
        message.error('Not enough balance in your account');
        return false;
    }
    return true;
};